import React from 'react'
import { darken } from 'polished'
import styled from 'styled-components'
import enabled from '../../lib/enabled'
import onClick from './lib/onClick'

const Container = styled.div`
  position: relative;
  display: flex;
  width: 20px;
  height: 20px;
  margin-right: 30px;

  @media (max-width: 768px) {
    margin-right: 20px;
  }
`

const Input = styled.input`
  opacity: 0;
  position: absolute;
`

const Box = styled.div`
  background-color: ${props => props.enabled ? props.theme.colors.green : props.theme.colors.white};
  border-radius: ${props => props.theme.borderRadius.light};
  width: 20px;
  height: 20px;
  position: absolute;
  cursor: pointer;
  border: ${props => props.enabled ? props.theme.borders.green3 : props.theme.borders.grey4};
  box-sizing: border-box;

  &:hover {
    border: ${props => props.theme.borders.green3};
    background-color: ${props => props.enabled ? darken(0.05, props.theme.colors.green) : props.theme.colors.white};
  }
`

const Mark = styled.div`
  position: absolute;
  left: 7px;
  top: 4px;
  width: 4px;
  height: 7px;
  border-color: ${props => props.theme.colors.white};
  border-style: solid;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
`

export default ({
  form,
  field,
  baseName,
  isItem,
}) => (
  <Container onClick={onClick(form, baseName, isItem)}>
    <Input
      id={field.name}
      type='checkbox'
      checked={enabled(form, baseName)}
      {...field}
    />
    <Box enabled={enabled(form, baseName)} />
    {enabled(form, baseName) && <Mark />}
  </Container>
)
